import React, { useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';

// Public site
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import PracticeAreas from './components/PracticeAreas';
import Partners from './components/Partners';
import Contact from './components/Contact';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';

// Admin portal
import { AuthProvider } from './admin/AuthContext';
import ProtectedRoute from './admin/ProtectedRoute';
import Login from './admin/Login';
import Dashboard from './admin/Dashboard';
import ClientDetail from './admin/ClientDetail';

export const LangContext = React.createContext('PT');

function PublicSite() {
  const [lang, setLang] = useState('PT');
  return (
    <LangContext.Provider value={lang}>
      <div className="App">
        <Navbar onLangChange={setLang} />
        <main>
          <Hero />
          <About />
          <PracticeAreas />
          <Partners />
          <Contact />
        </main>
        <Footer />
        <WhatsAppButton />
      </div>
    </LangContext.Provider>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/escritorio" element={<Login />} />
          <Route path="/escritorio/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/escritorio/cliente/:id" element={<ProtectedRoute><ClientDetail /></ProtectedRoute>} />
          <Route path="/*" element={<PublicSite />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
